/** Workflow progress chip (Not started / In progress / Complete) — shared firm tables. */
export function firmLiveAnalysisWorkflowStatusChipClass(statusLabel: string): string {
  const normalized = String(statusLabel ?? '')
    .trim()
    .toLowerCase();
  if (normalized === 'complete') {
    return 'bg-emerald-100/80 border border-emerald-200/60 text-emerald-800';
  }
  if (normalized === 'in progress' || normalized.includes('in progress')) {
    return 'bg-amber-100/80 border border-amber-200/60 text-amber-800';
  }
  return 'bg-gray-100/80 border border-gray-200/60 text-gray-600';
}

export function formatFirmAnalysisDealPrice(dealPrice: number | null | undefined): string {
  if (typeof dealPrice !== 'number' || Number.isNaN(dealPrice)) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  }).format(dealPrice);
}

export function formatFirmAnalysisAfr(afr: number | null | undefined): string {
  if (typeof afr !== 'number' || Number.isNaN(afr)) return '—';
  return `${afr}%`;
}

/** Subtitle under analysis name on company detail (medium date + time). */
export function formatFirmAnalysisUpdatedSubtitle(updatedAtIso: string | null | undefined): string | null {
  if (!updatedAtIso?.trim()) return null;
  const d = new Date(updatedAtIso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}
